import { checkoutWidgetsSchema } from "@redotech/redo-model/checkouts/checkout-widgets-builder";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const updateCheckoutWidgetInputSchema_ = z.object({
  widgetId: zExt.objectId(),
  widgetData: checkoutWidgetsSchema,
});

export const updateCheckoutWidget = {
  name: "updateCheckoutWidget" as const,
  input: updateCheckoutWidgetInputSchema_,
  output: z.object({}),
};
